import { render, staticRenderFns } from "./TagNew.vue?vue&type=template&id=61327d4e&scoped=true"
import script from "./TagNew.vue?vue&type=script&lang=ts"
export * from "./TagNew.vue?vue&type=script&lang=ts"
import style0 from "./TagNew.vue?vue&type=style&index=0&id=61327d4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61327d4e",
  null
  
)

export default component.exports